var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('element',[_c('AppBar',{attrs:{"title":"ReviewInvoice"}}),_c('v-container',[_c('h3',{staticClass:"category-label w-100 text-center"},[_vm._v("This is second dummy view for test.")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }